import { FormattedMessage } from 'react-intl';

export const messages = {
  'upload-image-modal.title': (
    <FormattedMessage
      id="upload-image-modal.title"
      defaultMessage="Upload image"
    />
  ),
  'upload-image-modal.description': (
    <FormattedMessage
      id="upload-image-modal.description"
      defaultMessage="Upload the background of your certificate to appear on your certificate"
    />
  ),
  'upload-image-modal.upload-button-text': (
    <FormattedMessage
      id="upload-image-modal.upload-button-text"
      defaultMessage="Choose image"
    />
  ),
  'upload-image-modal.submit-button-text': (
    <FormattedMessage
      id="upload-image-modal.submit-button-text"
      defaultMessage="Submit"
    />
  ),
  'upload-image-modal.cancel-button-text': (
    <FormattedMessage
      id="upload-image-modal.cancel-button-text"
      defaultMessage="Cancel"
    />
  ),
  'upload-image-modal.submit.unexpected-error': (
    <FormattedMessage
      id="upload-image-modal.submit.unexpected-error"
      defaultMessage="Error uploading image. Please try again or contact support."
    />
  ),
};
